/* jshint ignore:start */
}(window.dataLayer = window.dataLayer || [], window.SetDesign, window.lodash, jQuery, window, document));
/* jshint ignore:end */
